/* eslint-disable */
import { Container, Paper, Text } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const TermsTab = () => {
  const { lang } = useTranslation('client')

  return (
    <Container size="sm">
      <Paper>
        {lang === 'en' ? (
          <div style={{ marginBottom: 30 }}>
            <Text size="xl" weight={700} style={{ marginBottom: 20 }}>
              Terms and Conditions
            </Text>
            <Text size="lg">
              These terms and conditions ("Terms") govern your use of Infinity
              Medical Academy website and services (collectively, the
              "Services"). By accessing or using the Services, you agree to be
              bound by these Terms. If you do not agree to these Terms, you may
              not access or use the Services.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              1. Use of Services
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Account Registration:
                    </span>{' '}
                    In order to access certain features of the Services, you may
                    be required to register for an account. You agree to provide
                    accurate, current, and complete information during the
                    registration process and to update such information as
                    necessary to keep it accurate, current, and complete.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>User Conduct:</span>{' '}
                    You agree not to use the Services for any unlawful or
                    prohibited purpose, or in any manner that could damage,
                    disable, overburden, or impair the Services. You further
                    agree not to interfere with the security or integrity of the
                    Services or any associated systems or networks.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              2. Intellectual Property
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>Ownership:</span> All
                    content, materials, and intellectual property rights
                    associated with the Services are owned or licensed by
                    Infinity Medical Academy. You may not use, reproduce,
                    distribute, or modify any content or materials from the
                    Services without prior written consent from Infinity Medical
                    Academy.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>Trademarks:</span>{' '}
                    Infinity Medical Academy and its logo are trademarks of
                    Infinity Medical Academy. You may not use these trademarks
                    without prior written permission from Infinity Medical
                    Academy.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              3. Privacy Policy
            </Text>
            <Text size="lg">
              Your use of the Services is subject to Infinity Medical Academy's
              Privacy Policy, which is incorporated into these Terms by
              reference. By using the Services, you consent to the collection,
              use, and disclosure of your personal information as described in
              the Privacy Policy.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              4. Conditions for Obtaining a Certificate of Attendance at a
              Training Course
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Pre-Registration and Attendance Commitment:
                    </span>{' '}
                    Trainees are required to pre-register for the training
                    course and commit to attending it.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Attendance Requirement:
                    </span>{' '}
                    Trainees must attend a minimum of 70% of the total training
                    course time to be eligible for a certificate of attendance
                    and CME hours.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              5. Conditions for Trainees to Agree to Register Attendance at the
              Training Program
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Target Group Eligibility:
                    </span>{' '}
                    Trainees must belong to the target group for the training
                    program, as it is specifically designed to meet their needs
                    and requirements.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Commitment to Policies:
                    </span>{' '}
                    Trainees are obligated to thoroughly review and agree to the
                    policies and conditions outlined in the electronic
                    registration form before registering for the training
                    program.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Exclusion from Teaching Hours:
                    </span>{' '}
                    Trainees who register in a course not designated for the
                    target group are not entitled to claim CME hours.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              6. Limitation of Liability
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Disclaimer of Warranties:
                    </span>{' '}
                    THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT
                    WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. Infinity
                    Medical Academy DISCLAIMS ALL WARRANTIES, EXPRESS OR
                    IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES
                    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
                    NONINFRINGEMENT.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Limitation of Liability:
                    </span>{' '}
                    TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, Infinity
                    Medical Academy SHALL NOT BE LIABLE FOR ANY INDIRECT,
                    INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
                    INCLUDING, BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS,
                    REVENUE, DATA, OR USE, INCURRED BY YOU OR ANY THIRD PARTY,
                    WHETHER IN AN ACTION IN CONTRACT OR TORT, ARISING FROM YOUR
                    ACCESS TO OR USE OF THE SERVICES.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              7. Governing Law
            </Text>
            <Text size="lg">
              These Terms shall be governed by and construed in accordance with
              the laws of the Kingdom of Saudi Arabia, without regard to its
              conflict of law provisions.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              8. Changes to Terms
            </Text>
            <Text size="lg">
              Infinity Medical Academy reserves the right to modify or revise
              these Terms at any time, in its sole discretion. Any changes to
              these Terms will be effective immediately upon posting the revised
              Terms on the Services. Your continued use of the Services
              following the posting of the revised Terms constitutes your
              acceptance of such changes.
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              9. Subscription and Payment Policy
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>Advance Payment:</span>{' '}
                    Trainees must pay in advance using the electronic payment
                    method provided on the center’s website.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Accuracy of Information:
                    </span>{' '}
                    Trainees must ensure that all information provided during
                    registration is true and accurate.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Responsibility for Incorrect Information:
                    </span>{' '}
                    The center is not responsible for failure to implement
                    requests due to incorrect information provided by trainees.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>VAT:</span> All fees
                    are subject to a 15% VAT.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              10. Cancellation and Withdrawal Policy
            </Text>
            <Text size="lg">
              <ol>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Refunds for Canceled Programs:
                    </span>{' '}
                    If the program is canceled by the center or seats are
                    unavailable, the amount paid will be refunded to the
                    customer.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Confirmation of Registration:
                    </span>{' '}
                    Registration for any course or program is confirmed after
                    approval by the center and availability of seats.
                  </Text>
                </li>
                <li>
                  <Text size="lg">
                    <span style={{ fontWeight: 'bold' }}>
                      Refund Conditions:
                    </span>{' '}
                    In the case of a refund, 25% will be deducted from the
                    amount paid for value-added tax and electronic payment. This
                    condition is applicable if the refund request is made before
                    the date of the training activity. No amounts will be
                    refunded after the date of the training activity. The amount
                    can be transferred to the trainee’s internal wallet if they
                    so desire. Deduction for Refunds: In case of a refund, 25%
                    of the amount paid will be deducted for VAT and electronic
                    payment.
                  </Text>
                </li>
              </ol>
            </Text>

            <Text
              size="xl"
              weight={700}
              style={{ marginTop: 20, marginBottom: 10 }}
            >
              Contact Information
            </Text>
            <Text size="lg">
              For inquiries or assistance, please contact us through the Contact
              Us form on our website. We welcome your questions, concerns, and
              comments about our services.
            </Text>
          </div>
        ) : (
          <div dir="rtl">
            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                3. سياسة الخصوصية
              </Text>
              <Text size="lg">
                استخدامك للخدمات يخضع لسياسة الخصوصية لـ Infinity Medical
                Academy، والتي يتم دمجها في هذه الشروط بالإشارة إليها. من خلال
                استخدام الخدمات، فإنك توافق على جمع واستخدام والكشف عن معلوماتك
                الشخصية كما هو موضح في سياسة الخصوصية.
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                4. الشروط للحصول على شهادة الحضور في دورة تدريبية
              </Text>
              <Text size="lg">
                <ol>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        التسجيل المسبق والالتزام بالحضور:
                      </span>{' '}
                      يتعين على المتدربين التسجيل المسبق للدورة التدريبية
                      والالتزام بحضورها.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        متطلبات الحضور:
                      </span>{' '}
                      يجب على المتدربين الحضور لنسبة لا تقل عن 70% من وقت الدورة
                      التدريبية الإجمالي ليكونوا مؤهلين للحصول على شهادة الحضور
                      وساعات التعليم المستمر الطبي.
                    </Text>
                  </li>
                </ol>
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                5. الشروط للمتدربين للموافقة على تسجيل الحضور في برنامج التدريب
              </Text>
              <Text size="lg">
                <ol>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        أهلية المجموعة المستهدفة:
                      </span>{' '}
                      يجب أن ينتمي المتدربون إلى الفئة المستهدفة لبرنامج
                      التدريب، حيث يتم تصميمه خصيصًا لتلبية احتياجاتهم
                      ومتطلباتهم.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        الالتزام بالسياسات:
                      </span>{' '}
                      يتعين على المتدربين الالتزام بمراجعة والموافقة على
                      السياسات والشروط الموضحة في نموذج التسجيل الإلكتروني قبل
                      التسجيل في برنامج التدريب.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        استثناء من ساعات التدريس:
                      </span>{' '}
                      لا يحق للمتدربين الذين يسجلون في دورة غير مخصصة للفئة
                      المستهدفة المطالبة بساعات التعليم المستمر الطبي.
                    </Text>
                  </li>
                </ol>
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                6. تحديد المسؤولية
              </Text>
              <Text size="lg">
                <ol>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        إخلاء المسؤولية من الضمانات:
                      </span>{' '}
                      يتم توفير الخدمات "كما هي" و "كما متاحة" دون أي ضمانات من
                      أي نوع، سواء كانت صريحة أو ضمنية. تخلي Infinity Medical
                      Academy عن جميع الضمانات، سواء كانت صريحة أو ضمنية، بما في
                      ذلك ولكن لا تقتصر على الضمانات الضمنية للتسويق، والملاءمة
                      لغرض معين، وعدم الانتهاك.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        حدود المسؤولية:
                      </span>{' '}
                      في أقصى حد يسمح به القانون المعمول به، لن يكون Infinity
                      Medical Academy مسؤولة عن أي أضرار غير مباشرة، أو عرضية،
                      أو خاصة، أو عقابية، بما في ذلك ولكن لا تقتصر على الأضرار
                      بسبب فقدان الأرباح، أو الإيرادات، أو البيانات، أو
                      الاستخدام، التي تكبدتها أنت أو أي طرف ثالث، سواء في دعوى
                      قانونية أو جنائية، ناتجة عن استخدامك للخدمات أو وصولك
                      إليها.
                    </Text>
                  </li>
                </ol>
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                7. القانون الساري
              </Text>
              <Text size="lg">
                يجب أن تخضع هذه الشروط للقوانين السارية في المملكة العربية
                السعودية، دون النظر إلى أحكام التعارض فيها.
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                8. التغييرات على الشروط
              </Text>
              <Text size="lg">
                تحتفظ Infinity Medical Academy بالحق في تعديل أو مراجعة هذه
                الشروط في أي وقت، بتقديرها الوحيد. ستكون أي تغييرات على هذه
                الشروط فعالة على الفور بعد نشر الشروط المنقحة على الخدمات. يشكل
                استمرارك في استخدام الخدمات بعد نشر الشروط المنقحة موافقتك على
                مثل هذه التغييرات.
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                9. سياسة الاشتراك والدفع
              </Text>
              <Text size="lg">
                <ol>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>الدفع المسبق:</span>{' '}
                      يجب على المتدربين الدفع مقدمًا باستخدام الطريقة
                      الإلكترونية للدفع المتوفرة على موقع المركز.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>دقة المعلومات:</span>{' '}
                      يجب على المتدربين التأكد من أن جميع المعلومات المقدمة
                      أثناء التسجيل صحيحة ودقيقة.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        المسؤولية عن المعلومات الغير صحيحة:
                      </span>{' '}
                      لا يتحمل المركز مسؤولية عدم تنفيذ الطلبات بسبب المعلومات
                      الغير صحيحة التي قدمها المتدربون.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        ضريبة القيمة المضافة:
                      </span>{' '}
                      جميع الرسوم خاضعة لضريبة القيمة المضافة بنسبة 15٪.
                    </Text>
                  </li>
                </ol>
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                10. سياسة الإلغاء والانسحاب
              </Text>
              <Text size="lg">
                <ol>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        المبالغ المستردة للبرامج الملغاة:
                      </span>{' '}
                      إذا تم إلغاء البرنامج من قبل المركز أو عدم توفر المقاعد،
                      سيتم استرداد المبلغ المدفوع للعميل.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>تأكيد التسجيل:</span>{' '}
                      يتم تأكيد التسجيل لأي دورة أو برنامج بعد الموافقة من قبل
                      المركز وتوفر المقاعد.
                    </Text>
                  </li>
                  <li>
                    <Text size="lg">
                      <span style={{ fontWeight: 'bold' }}>
                        شروط الاسترداد:
                      </span>{' '}
                      في حالة الاسترداد، سيتم خصم 25٪ من المبلغ المدفوع لضريبة
                      القيمة المضافة والدفع الإلكتروني. تطبق هذه الشروط إذا تم
                      طلب الاسترداد قبل تاريخ النشاط التدريبي. لن يتم استرداد أي
                      مبالغ بعد تاريخ النشاط التدريبي. يمكن تحويل المبلغ إلى
                      محفظة المتدرب الداخلية إذا كانوا يرغبون في ذلك. خصم
                      للإسترداد: في حالة الاسترداد، سيتم خصم 25٪ من المبلغ
                      المدفوع لضريبة القيمة المضافة والدفع الإلكتروني.
                    </Text>
                  </li>
                </ol>
              </Text>
            </div>

            <div style={{ marginTop: 20, marginBottom: 10 }}>
              <Text size="xl" weight={700} style={{ marginBottom: 10 }}>
                معلومات الاتصال
              </Text>
              <Text size="lg">
                للاستفسار أو المساعدة، يرجى الاتصال بنا من خلال نموذج اتصل بنا
                المتوفر على موقعنا الإلكتروني. نرحب بأسئلتكم واهتماماتكم
                وتعليقاتكم حول خدماتنا.
              </Text>
            </div>
          </div>
        )}
      </Paper>
    </Container>
  )
}

export default TermsTab
